/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Pauze_Greep_UitlegInputs */

const nl_planning_rooster_pauze_greep_uitleg = /** @type {(inputs: Planning_Rooster_Pauze_Greep_UitlegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep om de pauze te verplaatsen, klik voor de naam`)
};

/**

* @param {Planning_Rooster_Pauze_Greep_UitlegInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_greep_uitleg = /** @type {((inputs?: Planning_Rooster_Pauze_Greep_UitlegInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_Greep_UitlegInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_greep_uitleg(inputs)
});
export { planning_rooster_pauze_greep_uitleg as "planning.rooster.pauze_greep_uitleg" }